import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    // 更新狀態以便下一次渲染會顯示備用UI。
    return { hasError: true, error: error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {

    // 您也可以將錯誤記錄到錯誤報告服務中。
    //logErrorToMyService(error, errorInfo);
  }

  copyErrorDetailsToClipboard = (): void => {
    const errorDetails = `${this.state.error?.message}\n\n${this.state.error?.stack}`;
    navigator.clipboard.writeText(errorDetails);
    alert('已複製錯誤訊息');
  };

  render() {
    if (this.state.hasError) {
      // 您可以渲染任何自定義的備用UI。
      return (
        <div style={{
          padding: '16px',
          // overflow:'scroll'
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h4 style={{ marginRight: '16px', marginTop: 0, marginBottom: 0 }}>
              發生錯誤!
            </h4>
            <button onClick={this.copyErrorDetailsToClipboard}>
              複製錯誤訊息
            </button>
          </div>
          <p>
            <h6 style={{ marginRight: '16px', marginTop: 0, marginBottom: 0 }}>
              {this.state.error?.message}
            </h6>
          </p>
          <pre style={{ color: '#AAAAAA' }}>{this.state.error?.stack}</pre>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;